import set from 'lodash/set'
import api from '../../../../api'

class Result {
  constructor(object, err) {
    this.object = object
    this.err = err
  }

  isSuccess() {
    return !!this.object && !this.err
  }

  getErrorMessage() {
    if (!this.err) return ''
    return this.err
  }

  getErrors() {
    if (!this.err) return []

    if (this.err.response && this.err.response.errors) {
      const { errors } = this.err.response

      Object.keys(errors).forEach(key => {
        switch (key) {
          case 'currentDevice.serialNumber':
            set(errors, 'deviceSerialNumber', errors[key][0])
            delete errors[key]
            break
          case 'currentDevice.deviceModel':
            set(errors, 'deviceModelId', errors[key][0])
            delete errors[key]
            break
          default:
        }
      })

      return errors
    }

    return this.err.message
  }
}

const getOrCreatePatient = async (
  id,
  practiceId,
  {
    firstName,
    lastName,
    dateOfBirth,
    practiceMrn,
    deviceModelId,
    deviceSerialNumber,
  },
) => {
  try {
    if (id) {
      return new Result(await api.patients.get(id), undefined)
    }

    return new Result(
      await api.patients.create({
        practiceId,
        firstName,
        lastName,
        birthDate: dateOfBirth?.toISOString(),
        practiceMrn,
        currentDeviceAttributes: {
          deviceModelId,
          serialNumber: deviceSerialNumber,
        },
        approved: false,
        remoteMonitoring: true,
      }),
      undefined,
    )
  } catch (e) {
    return new Result(undefined, e)
  }
}

const createUpload = async formData => {
  try {
    const response = await api.transmissions.create(formData)
    if (response[0] && response[0].error) {
      return new Result(undefined, response[0].message)
    }
    return new Result(response, undefined)
  } catch (e) {
    return new Result(undefined, e.message)
  }
}

export default async (patientId, practiceId, patient, attributes, file) => {
  const {
    firstName,
    lastName,
    dateOfBirth,
    practiceMrn,
    deviceModelId,
    deviceSerialNumber,
    remoteMonitoring,
  } = attributes

  const patientCreationResult = await getOrCreatePatient(
    patientId,
    practiceId,
    {
      firstName,
      lastName,
      dateOfBirth,
      practiceMrn,
      deviceModelId,
      deviceSerialNumber,
      remoteMonitoring,
    },
  )

  const fd = new FormData()
  fd.append('transmission_file', file)
  fd.append('transmission_date', attributes.transmissionDate)
  fd.append(
    'device_identifier',
    patientCreationResult.object.currentDevice.serialNumber,
  )
  fd.append('device_id', patientCreationResult.object.currentDevice.id)
  fd.append('patient_id', patientCreationResult.object.id)

  const createUploadResult = await createUpload(fd)

  return [patientCreationResult, createUploadResult]
}
